export class FindKeiyakushaResult {
    userCd = -1;
    userKb = -1;
    userName = "";
    buknCd = -1;
    buknName = "";
    roomNo = "";
    email = "";
    kankatsuKb = -1;
    loginId = "";
}
